import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { CashFlowPage } from '../../features/reports/cash-flow-page'
import { cashFlowSearchSchema } from '../../features/reports/search'

export const Route = createFileRoute('/_app/cash-flow')({
  staticData: { crumb: 'cashFlow' },
  validateSearch: cashFlowSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'reports.financial'),
  component: CashFlowPage,
})
